import React from "react";
import { FormattedMessage } from "react-intl";

import { HelpSearch } from "../HelpSearch/HelpSearch";
import { Desktop, TabletMobile } from "../../../common/Responsive";
import { NavigationMenu } from "./NavigationMenu/NavigationMenu";

import "./HelpNavigation.scss";

export const HelpNavigation = () => (
  <div className={"help-navigation"}>
    <TabletMobile>
      <div className="help-navigation__search">
        <HelpSearch />
      </div>
    </TabletMobile>
    <Desktop>
      <h1>
        <FormattedMessage id={"help_page"} />
      </h1>
      <HelpSearch />
      <NavigationMenu />
    </Desktop>
  </div>
);
